export default {
  mapsKey: 'AIzaSyCEi7mAPiIM-myyZYnv_OsDXiQvBxAxxqs'
}